import Button from "../../Components/Button";
import { ISahraUserGroupsReport } from "../../Interfaces/sahraUserGroupsInterfaces";
import { IAdditional } from "../TableTemplate/tableTemplate";
import TableCell from "@mui/material/TableCell/TableCell";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Tooltip } from "@mui/material";
import { useContext, useState } from "react";
import { SahraUserGroupsTableContext } from "./SahraUserGroupsTable";
import Modal from "../../Components/Modal/Modal";
import { deleteSahraUserGroup } from "../../Requests/sahraUserGroupRequests";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";

const SahraUserGroupTableAdditionalHeader: React.FC = () => <TableCell />;

const SahraUserGroupAdditionalCol: React.FC<{
  row: ISahraUserGroupsReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const { onEdit } = useContext(SahraUserGroupsTableContext);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const editHandler = () => {
    onEdit(row);
  };

  const deleteHandler = () => {
    setIsDeleting(true);
    deleteSahraUserGroup(row.id)
      .then((response) => {
        if (!response.data) {
          toast.error(response.msg);
          return;
        }

        toast.success(response.msg);
        setIsDeleteOpen(false);
        onAction();
      })
      .catch(packetErrorHandler)
      .finally(() => setIsDeleting(false));
  };

  return (
    <TableCell>
      {isDeleteOpen ? (
        <Modal title="حذف دسته‌بندی اکانت"
          onClose={() => setIsDeleteOpen(false)}
          modalBoxClassName="compact-confirm-modal"
          UI={
            <div
              dir="rtl"
              className="w-full flex flex-col gap-6 items-stretch text-right"
            >
              <div className="flex flex-col gap-2">
                <div className="text-base font-bold text-slate-800">
                  حذف دسته‌بندی اکانت
                </div>
                <div className="text-sm leading-6 text-slate-600">
                  آیا از حذف دسته‌بندی «{row.name}» مطمئن هستید؟ اکانت‌های
                  داخل دسته حذف نمی‌شوند. دسته‌بندیِ در حال استفاده توسط
                  کاربر سایت قابل حذف نیست.
                </div>
              </div>
              <div className="flex flex-row gap-2 w-full">
                <Button
                  text="انصراف"
                  variant="outlined"
                  onClick={() => setIsDeleteOpen(false)}
                />
                <Button
                  text="حذف دسته‌بندی"
                  variant="contained"
                  onClick={deleteHandler}
                  loading={isDeleting}
                />
              </div>
            </div>
          }
        />
      ) : null}
      <div className="flex flex-row gap-2 w-min">
        <Tooltip title="ویرایش" arrow>
          <Button
            className="table-btn"
            onClick={editHandler}
            text={<EditIcon className="!text-sm" />}
            variant="contained"
          />
        </Tooltip>
        <Tooltip title="حذف" arrow>
          <Button
            className="table-btn"
            onClick={() => setIsDeleteOpen(true)}
            text={<DeleteIcon className="!text-md" />}
            variant="contained"
          />
        </Tooltip>
      </div>
    </TableCell>
  );
};

export const SahraUsersGroupTableAdditional: IAdditional<ISahraUserGroupsReport> =
  {
    getHeader: SahraUserGroupTableAdditionalHeader,
    getRow: SahraUserGroupAdditionalCol,
  };
